<template>
  <div class="chatRoom">
    <div class="header">
      <div class="header_top">
        <div class="header_top_status">
          <span class="el-icon-time header_icon"></span>
          <span class="header_text">{{ statusFilters(orderInfo.status).text }}</span>
          <span v-if="statusFilters(orderInfo.status).remainingTime" class="header_time">{{ statusFilters(orderInfo.status).remainingTime }}</span>
        </div>
        <el-button class="header_top_btn" type="text" :disabled="inquiryFilters.disabled" @click="toInquiry()">{{ inquiryFilters.text }}</el-button>
      </div>
      <div v-if="orderInfo.inquiryInfo" class="header_inquiry">
        <div v-for="question in orderInfo.inquiryInfo.questions" :key="question.id" class="inquiry_item">
          <div v-if="question.questionsTitle === '病情描述'" :class="{ inquiry_description: true, hidden: !headerMoreShow }">{{question.selectAnswerId}}</div>
          <div v-else>
            <div v-show="headerMoreShow" :class="{ inquiry_row: question.questionsType != 3 }">
              <div v-if="question.questionsType != 3" class="inquiry_row_title">{{question.questionsTitle}}：</div>
              <div v-if="question.questionsType == 3" class="inquiry_row_imgRow">
                <img v-for="(conditionImg, conditionImgIndex) in question.imgList" :key="conditionImgIndex" class="inquiry_row_img" :src="conditionImg">
              </div>
              <div v-else>
                <div v-if="question.answers && question.answers.length > 0">
                  <div v-for="answer in question.answers" :key="answer.id" v-if="question.selectAnswerId == answer.answerId" class="inquiry_answer_text">{{ answer.answerContent }}</div>
                </div>
                <div v-else class="inquiry_answer_text">{{ question.selectAnswerId }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header_more" @click="headerMoreShowChange">
        <span class="header_more_text">{{ headerMoreShow ? '收起' : '展开' }}</span>
        <span :class="{ 'el-icon-arrow-down': !headerMoreShow, 'el-icon-arrow-up': headerMoreShow, 'header_more_icon': true }"></span>
      </div>
    </div>
    <div class="content" ref="chat_content" v-loading="chatLoading" @scroll="chatScroll">
      <div class="chat_list">
        <div v-for="chat in chatMap.list" :key="chat.vId" :ref="`chat_record_${chat.vId}`" class="chat_item">
          <div v-if="chat.messageType === 2" class="chat_system">
            <div class="chat_system_text">{{ chat.content }}</div>
          </div>
          <div v-else :class="{ chat_user: true, other: chat.sendRole != '0', mine: chat.sendRole == '0' }">
            <img class="chat_headImg" :src="chat.sendRole == '0' ? orderInfo.doctorMap.headerImg : imgArr.chat_user">
            <div :class="{ chat_info: true, mine: chat.sendRole == '0' && [0].includes(chat.messageType) }">
              <div v-if="chat.messageType === 0" class="chat_text">{{ chat.content }}</div>
              <div v-if="chat.messageType === 1" class="chat_image">
                <!-- <img class="chat_image_img" :src="chat.content" /> -->
                <el-image class="chat_image_img" :src="chat.content" :preview-src-list="[chat.content]"></el-image>
              </div>
              <div v-if="chat.messageType === 3" class="chat_voice">
                <audio class="chat_voice_audio" :src="chat.content.content" controls></audio>
              </div>
              <div v-if="chat.messageType === 4" class="chat_inquiry" @click="toInquiry(chat)">
                <div class="inquiry_title">问诊单</div>
                <div class="inquiry_info">{{ chat.content.webChatInquiryInfo.status == '0' ? '患者未填写' : (chat.content.webChatInquiryInfo.status == '1' ? '患者已填写完成' : '') }}</div>
                <div :class="{ inquiry_footer: true, finished: chat.content.webChatInquiryInfo.status == '1' }">{{ chat.content.webChatInquiryInfo.status == '0' ? '等待患者填写' : '查看问诊单' }}</div>
              </div>
              <div v-if="chat.messageType === 8" class="chat_plan">
                <div class="plan_header">
                  <div class="plan_header_title">治疗方案</div>
                  <div v-if="chat.content.diagnosisResp && chat.content.diagnosisResp.status" class="plan_header_status" :style="`color: ${ planOrderStatusMap[chat.content.diagnosisResp.status + ''].color }`">{{ planOrderStatusMap[chat.content.diagnosisResp.status + ''].label }}</div>
                  <div v-else-if="chat.orderInfoStatus" class="plan_header_status" :style="`color: ${ planOrderInfoStatusMap[chat.orderInfoStatus + ''].color }`">{{ planOrderInfoStatusMap[chat.orderInfoStatus + ''].label }}</div>
                </div>
                <div class="plan_patient">患者： {{ chat.content.patient.patientName }} {{ chat.content.patient.sex == 0 ? '男' : '女' }} {{ chat.content.patient.age }}岁</div>
                <div v-if="chat.content.diagnosisResp" class="plan_diagnosis">诊断： {{ chat.content.diagnosisResp.diagnosis }}</div>
                <div v-if="chat.content" class="plan_content">
                  <span>方案：</span>
                  <span v-if="chat.content.chDoseNum">中药处方{{ chat.content.chDoseNum }}剂，</span>
                  <span v-if="chat.content.physioItems">理疗项目{{ chat.content.physioItems }}项，</span>
                  <span v-if="chat.content.otherItems">其他项目{{ chat.content.otherItems }}项，</span>
                </div>
              </div>
              <div v-if="chat.messageType === 10" class="chat_condition" @click="toInquiry(chat)">
                <div class="condition_title">病情描述</div>
                <div v-if="chat.content.webChatInquiryInfo" class="condition_list">
                  <div v-for="question in chat.content.webChatInquiryInfo.questions" :key="question.id" class="condition_item">
                    <div v-if="question.questionsTitle === '病情描述'" class="condition_description">{{question.questionsTitle}}：{{question.selectAnswerId}}</div>
                    <div v-else :class="{ condition_row: question.questionsType != 3 }">
                      <div v-if="question.questionsType != 3 || (question.questionsType == 3 && question.imgList.length > 0)" class="condition_row_title">{{question.questionsTitle}}：</div>
                      <div v-if="question.questionsType == 3" class="condition_row_imgRow">
                        <img v-for="(conditionImg, conditionImgIndex) in question.imgList" :key="conditionImgIndex" class="condition_row_img" :src="conditionImg">
                      </div>
                      <div v-else>
                        <div v-if="question.answers && question.answers.length > 0">
                          <div v-for="answer in question.answers" :key="answer.id" v-if="question.selectAnswerId == answer.answerId" class="condition_answer_text">{{ answer.answerContent }}</div>
                        </div>
                        <div v-else class="condition_answer_text">{{ question.selectAnswerId }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="condition_footer">查看病情描述</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer_tools">
        <div class="tools_header">
          <div class="tools_header_left">
            <span class="el-icon-menu tools_header_left_icon"></span>
            <span class="tools_header_left_text">工具栏</span>
          </div>
          <div class="tools_header_right">
            <span :class="{ 'el-icon-d-arrow-left': !toolMap.show, 'el-icon-d-arrow-right': toolMap.show, 'tools_header_right_icon': true }" @click="toolShowChange"></span>
          </div>
        </div>
        <div v-show="toolMap.show" class="tools_list">
          <div v-for="tool in toolMap.list" :key="tool.id" class="tools_item" @click="tool.event">
            <div class="tools_btn_block">
              <img class="tools_btn_icon" :src="tool.img" />
            </div>
            <div class="tools_btn_title">{{ tool.name }}</div>
          </div>
        </div>
      </div>
      <div class="footer_input">
        <el-input class="footer_input_textarea" type="textarea" v-model="chatInput" placeholder="输入内容" resize="none" @keydown.enter.native.prevent="sendText" :disabled="!isReady"></el-input>
        <div class="footer_input_btn">
          <el-button type="primary" size="small" @click="sendText">发送</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      title="赠送时长"
      class="chatRoom_dialog"
      :visible.sync="giveTimeMap.visible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeGiveTime">
      <div class="giveTime_dialog_content">
        <el-form ref="giveTimeForm" :model="giveTimeMap.form" :rules="giveTimeMap.rules" label-width="100px">
          <el-form-item label="选择时长：" prop="time">
            <el-select class="giveTime_select" popper-class="giveTime_select_popper" v-model="giveTimeMap.form.time" placeholder="请选择时长">
              <div class="giveTime_select_grid">
                <el-option v-for="(time, timeIndex) in giveTimeMap.list" :key="timeIndex" :label="time.label" :value="time.value"></el-option>
              </div>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="submitGiveTime">确 定</el-button>
        <el-button @click="closeGiveTime">取 消</el-button>
      </div>
    </el-dialog>
    <InquirySelect ref="inquirySelect"></InquirySelect>
    <InquiryDetail ref="inquiryDetail"></InquiryDetail>
    <ChatHistory ref="chatHistory"></ChatHistory>
    <Upload
      ref="uploadImage"
      accept=".png,.jpg,.jpeg"
      style="display: none;"
      @on-success="uploadImageSuccess">
    </Upload>
  </div>
</template>

<script>
  import { imgArr } from "@/assets/images/img.js"

  import { isEmptyArray } from '@/utils/validateBase'
  import { debounce } from '@/utils/validateBase'

  import SelectPanel from '@/components/SelectPanel.vue'

  import Upload from "@/components/Upload/Upload"
  import InquirySelect from './inquirySelect.vue'
  import InquiryDetail from './inquiryDetail.vue'
  import ChatHistory from './chatHistory.vue'

  import {
    webChatDetails,
    getInquiryListApi,
    getWebchatRecords,
    sendGiftTimeApi,
    outPatientApi,
    completeWebChat,
    chatPatientApi,
    setReadWebChatMsg
  } from "@/api/webchat"
  export default {
    name: 'ChatRoom',
    components: { SelectPanel, Upload, InquirySelect, InquiryDetail, ChatHistory },
    data() {
      return {
        imgArr: imgArr,
        isReady: false,
        remainingTimeClock: null,
        chatHeartClock: null,
        chatSocket: null,
        chatLoading: false,
        orderId: '',
        inquiryList: [],
        orderInfo: {
          webChatOrderInfoId: '',
          status: '',
          timeOut: '',
          remainingTime: '',
          allTime: '',
          completeTime: '',
          createTime: '',
          inquiryInfo: null,
          doctorMap: {
            doctorId: '',
            doctorName: '',
            headerImg: ''
          },
          patientMap: {
            patientId: '',
            patientName: '',
            headerImg: ''
          },
          existCtOrder: null,
          isReply: 0
        },
        chatMap: {
          hasMore: true,
          list: [],
          pageNo: 1,
          pageSize: 20
        },
        handleStatusMap: {
          '-1': { label: '咨询已超时' },
          '-2': { label: '患者已退号' },
          '-7': { label: '患者已退费' },
          '2': { label: '患者已付费' },
          '3': { label: '咨询已结束' },
        },
        planOrderStatusMap: {
          '-7': { label: '已退费', color: '#667182' },
          '-5': { label: '已超时', color: '' },
          '-4': { label: '已跑单', color: '' },
          '-3': { label: '已退款', color: '' },
          '-2': { label: '已停诊', color: '' },
          '-1': { label: '已取消', color: '#667182' },
          '0': { label: '未支付', color: '#FE8F1F' },
          '1': { label: '待签到', color: '' },
          '2': { label: '待就诊', color: '' },
          '3': { label: '已就诊', color: '' },
          '4': { label: '已收费', color: '#29C01B' },
          '6': { label: '已完成', color: '' },
          '7': { label: '已叫号', color: '' },
          '8': { label: '待支付', color: '#FE8F1F' },
          '9': { label: '已关闭', color: '' },
          '11': { label: '待审核', color: '#1890FF' },
          '15': { label: '已拒绝', color: '#F54A45' }
        },
        planOrderInfoStatusMap: {
          '-7': { label: '已退费', color: '#667182' },
          '-6': { label: '草稿', color: '' },
          '-5': { label: '已超时', color: '' },
          '-4': { label: '已跑单', color: '' },
          '-3': { label: '已退款', color: '' },
          '-2': { label: '已停诊', color: '' },
          '-1': { label: '已取消', color: '#667182' },
          '0': { label: '未支付', color: '#FE8F1F' },
          '1': { label: '待签到', color: '' },
          '2': { label: '待就诊', color: '' },
          '3': { label: '已就诊', color: '' },
          '4': { label: '已划价', color: '#29C01B' },
          '5': { label: '正在看诊', color: '#29C01B' },
          '6': { label: '已完成', color: '' },
          '7': { label: '已叫号', color: '' },
          '8': { label: '待支付', color: '#FE8F1F' },
          '9': { label: '已关闭', color: '#667182' },
          '11': { label: '待审核', color: '#1890FF' },
          '15': { label: '已拒绝', color: '#F54A45' }
        },
        headerMoreShow: false,
        toolMap: {
          show: false,
          list: [
            { id: 1, name: '问诊单', img: imgArr.inquiry, event: this.toInquirySelect},
            { id: 2, name: '发送图片', img: imgArr.sendImage, event: this.toSendImage},
            { id: 3, name: '赠送时长', img: imgArr.giveTime, event: this.openGiveTime},
            { id: 4, name: '聊天记录', img: imgArr.chatHistory, event: this.toChatHistory},
            { id: 5, name: '退号', img: imgArr.refundNumber, event: this.toRefundNumber},
            { id: 6, name: '结束咨询', img: imgArr.overConsultation, event: this.toOverConsultation}
          ]
        },
        giveTimeMap: {
          visible: false,
          form: {
            time: ''
          },
          rules: {
            time: [{ required: true, message: '请选择赠送时长', trigger: 'change' }]
          },
          list: [
            { label: '赠送15分钟', value: '15' },
            { label: '赠送30分钟', value: '30' },
            { label: '赠送45分钟', value: '45' },
            { label: '赠送1小时', value: '60' },
            { label: '赠送2小时', value: '120' },
            { label: '赠送3小时', value: '180' },
            { label: '赠送6小时', value: '360' },
            { label: '赠送12小时', value: '720' },
            { label: '赠送24小时', value: '1440' }
          ]
        },
        chatInput: ''
      }
    },
    computed: {
      statusFilters () {
        return (status) => {
          let text = ''
          let remainingTime = ''
          switch (status) {
            case '1':
              text = `剩余时间：`
              remainingTime = this.orderInfo.remainingTime
              break
            case '2':
              text = `剩余时间：`
              remainingTime = this.orderInfo.remainingTime
              break
            case '4':
              text = `剩余时间：`
              remainingTime = this.orderInfo.remainingTime
              break
            case '-2':
              text = '已退号'
              break
            case '3':
              text = '已结束'
              break
            default:
              text = '已结束'
              break
          }
          return { text: text, remainingTime: remainingTime }
        }
      },
      inquiryFilters () {
        let inquiryMap = {
          text: '查看问诊单',
          disabled: false
        }
        if (this.inquiryList.length > 0) {
          const hasFinished = this.inquiryList.some(v => v.status == '1')
          if (hasFinished) {
            inquiryMap.text = '查看问诊单'
            inquiryMap.disabled = false
          } else {
            inquiryMap.text = '问诊单待填写'
            inquiryMap.disabled = true
          }
        } else {
          inquiryMap.text = '未发送问诊单'
          inquiryMap.disabled = true
        }
        return inquiryMap
      }
    },
    methods: {
      generateUUID () {
        return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0
          const v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      },
      updateWebchatDetail (data) {
        let type = data.content && data.content.messageType
        let id = data.content && data.content.id

        switch (type) {
          case 11: //网诊订单状态变化
            this.getOrderInfo()
            break;
          case 8: //就诊单状态变化
            break
          case 4: //问诊单状态变化
            let index = this.chatMap.list.findIndex(v => {
              let webChatInquiryInfo = !isEmptyArray(v.content) ? v.content.webChatInquiryInfo || {} : {}
              return webChatInquiryInfo.id == id && v.messageType == 4
            })
            if (index <= -1) return
            this.chatMap.list[index].content.webChatInquiryInfo.status = data.content.status
            this.getInquiryList()
            break
          default:
            break
        }
      },
      chatMsgHandle (data) {
        const info = JSON.parse(JSON.stringify(data))
        if (info.code === '0' && info.resultType === '0') {
          const isOperate = info.data.webChatOrderInfoId == this.orderInfo.webChatOrderInfoId && info.data.doctorId == this.orderInfo.doctorMap.doctorId && info.data.patientId == this.orderInfo.patientMap.patientId
          if (isOperate) {
            let result = info.data || {}
            if ([3, 4, 8, 12].includes(result.messageType)) {
              result.content = JSON.parse(result.content)
            }
            if (result.messageType === 12) {
              this.updateWebchatDetail(result)
              return
            }
            result = this.getPlanData(result)
            this.chatMap.list.push(result)
            this.$nextTick(() => {
              this.$refs['chat_content'].scrollTop = this.$refs['chat_content'].scrollHeight
            })
          }
        }
      },
      sendSocketMessage (message) {
        const nowMessage = message
        if (!this.chatSocket) {
          this.init()
          return
        }
        if (this.chatSocket.readyState !== WebSocket.OPEN) {
          this.$message.error('网络异常，尝试重发中...')
          setTimeout(() => {
            this.init()
          }, 2000)
          setTimeout(() => {
            this.sendSocketMessage(nowMessage)
          }, 5000)
          return
        }
        try {
          const msg = typeof nowMessage === 'string' ? nowMessage : JSON.stringify(nowMessage)
          this.chatSocket.send(msg)
        } catch (error) {
          this.$message.error('网络异常，尝试重发中...')
          setTimeout(() => {
            this.init()
          }, 2000)
          setTimeout(() => {
            this.sendSocketMessage(nowMessage)
          }, 5000)
        }
      },
      sendMessage (messageType, content, duration) {
        let parmas = {
          doctorId: String(this.orderInfo.doctorMap.doctorId),
          patientId: String(this.orderInfo.patientMap.patientId),
          messageType: messageType,
          webChatOrderInfoId: String(this.orderInfo.webChatOrderInfoId),
          content: content,
          type: 0,
          isReply: this.orderInfo.isReply == 0 ? 0 : null
        }
        if (duration) {
          parmas.content = {
            content,
            duration
          }
        }
        this.sendSocketMessage(parmas)
      },
      async socketInit() {
        if (this.chatSocket) {
          this.chatSocket.close()
          this.chatSocket = null
          clearInterval(this.chatHeartClock)
        }
        this.chatSocket = new WebSocket(`${process.env.VUE_APP_CHAT_WSS_URL}?type=0&id=${this.orderInfo.doctorMap.doctorId}`)
        // websocket打开连接
        this.chatSocket.onopen = () => {
          // 开始心跳
          this.chatHeartClock = setInterval(() => {
            this.chatSocket.send('heartCheck')
          }, 10000)
        }
        // websocket关闭
        this.chatSocket.onclose = () => {
          clearInterval(this.chatHeartClock)
        }
        // websocket错误
        this.chatSocket.onerror = (res) => {
          console.log(res)
        }
        // websocket接收消息
        this.chatSocket.onmessage = (res) => {
          const info = JSON.parse(res.data)
          if (info.code === '0' && info.resultType === '0' && info.data.messageType !== 9) {
            this.$emit('onlineInfoUpdate')
            this.readChatMsg()
          }
          this.chatMsgHandle(info)
        }
      },
      async chatRead () {
        const res = await chatPatientApi({
          userId: this.orderInfo.doctorMap.doctorId,
          chatObjId: this.orderInfo.patientMap.patientId
        })
      },
      async init (orderId) {
        clearInterval(this.remainingTimeClock)

        this.isReady = true

        this.orderId = orderId

        this.inquiryList = []

        this.chatMap.hasMore = true
        this.chatMap.list = []
        this.chatMap.pageNo = 1

        this.toolMap.show = false

        this.chatInput = ''

        await this.getOrderInfo()
        this.getInquiryList()
        this.getChatList()
        this.socketInit()
        this.chatRead()
        this.readChatMsg()
      },
      formatTime (ms) {
        const totalSeconds = Math.floor(ms / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        
        return [
          hours.toString().padStart(2, '0'),
          minutes.toString().padStart(2, '0'),
          seconds.toString().padStart(2, '0')
        ].join(':')
      },
      startRemainingTimeClock () {
        this.remainingTimeClock = setInterval(() => {
          const remainingTime = new Date(this.orderInfo.timeOut).getTime() - new Date().getTime()
          this.orderInfo.remainingTime = this.formatTime(remainingTime)
          if (remainingTime <= 0) {
            clearInterval(this.remainingTimeClock)
            this.getOrderInfo()
          }
        }, 1000)
      },
      async getOrderInfo () {
        const res = await webChatDetails({ orderId: this.orderId })
        if (res.code == 200) {
          this.orderInfo.webChatOrderInfoId = res.data.webChatOrderInfoId
          this.orderInfo.status = res.data.status
          this.orderInfo.timeOut = res.data.timeOut

          const remainingTime = new Date(res.data.timeOut).getTime() - new Date().getTime()
          this.orderInfo.remainingTime = this.formatTime(remainingTime)
          if (remainingTime > 0) {
            this.startRemainingTimeClock()
          }

          this.orderInfo.allTime = this.formatTime(new Date(res.data.timeOut).getTime() - new Date(res.data.payTime).getTime()).slice(0, -3)

          this.orderInfo.completeTime = res.data.completeTime && new Date(res.data.completeTime).Format('yyyy-MM-dd hh:mm:ss') || null
          this.orderInfo.createTime = res.data.createTime && new Date(res.data.createTime).Format('yyyy-MM-dd hh:mm:ss') || null

          res.data.webChatInquiryInfo.questions.map(v => {
            if (v.questionsType === 3) {
              v['imgList'] = (v.selectAnswerId && v.selectAnswerId.split(',')) || []
            }
          })
          this.orderInfo.inquiryInfo = res.data.webChatInquiryInfo
          
          this.orderInfo.doctorMap.doctorId = res.data.doctor.doctorId
          this.orderInfo.doctorMap.doctorName = res.data.doctor.doctorName
          this.orderInfo.doctorMap.headerImg = res.data.doctor.doctorImgAddr

          this.orderInfo.patientMap.patientId = res.data.patient.patientId
          this.orderInfo.patientMap.patientName = res.data.patient.patientName
          this.orderInfo.patientMap.headerImg = res.data.member && res.data.member.headImg || ''

          this.orderInfo.existCtOrder = res.data.existCtOrder
          this.orderInfo.isReply = res.data.isReply
        }
      },
      // 获取就诊单的方案 例：中药处方*剂  理疗项目*项 其他项目*项
      getPlanData(data) {
        if (data.messageType == 8) {
          let projectRecipes = data.content.projectRecipes || []
          // 中药  0:其他   1：中药   2：隐秘   3：理疗
          let items = projectRecipes.filter(vs => {
            return vs.recipeType == 1
          })
          let doseNum = items.reduce((pre, cur) => {
            return pre + cur.doseNum
          }, 0)
          data.content.chMed = items
          data.content.chDoseNum = doseNum
          // 理疗
          let physioItems = 0
          projectRecipes.map(vs => {
            if (vs.recipeType == 3) {
              physioItems += vs.items && vs.items.length
            }
          })
          data.content.physioItems = physioItems
          // 其他
          let otherItems = 0
          projectRecipes.map(vs => {
            if (vs.recipeType == 0) {
              otherItems += vs.items && vs.items.length
            }
          })
          data.content.otherItems = otherItems
        }
        return data
      },
      async getInquiryList () {
        const res = await getInquiryListApi({ webChatOrderInfoId: this.orderInfo.webChatOrderInfoId })
        if (res.code === 200) {
          this.inquiryList = res.rows.filter(v => { return v.templateId !== 29 })
        }
      },
      async getChatList () {
        this.chatLoading = true
        const res = await getWebchatRecords({
          webChatOrderInfoId: this.orderInfo.webChatOrderInfoId,
          doctorId: this.orderInfo.doctorMap.doctorId,
          patientId: this.orderInfo.patientMap.patientId,
          role: '0',
          pageNum: this.chatMap.pageNo,
          pageSize: this.chatMap.pageSize
        })
        this.chatLoading = false
        if (res.code === 200) {
          if (res.rows.length > 0) {
            const oldFirstChatVId = this.chatMap.list[0] && this.chatMap.list[0].vId || ''
            const list = res.rows.reverse()
            list.map(v => {
              v['vId'] = this.generateUUID()
              switch (v.messageType) {
                case 1:
                  v.content = v.content + `?v=${Date.now()}`
                  break
                case 3:
                  v.content = JSON.parse(v.content)
                  break
                case 4:
                  v.content = JSON.parse(v.content)
                  v = this.getPlanData(v)
                  break
                case 8:
                  v.content = JSON.parse(v.content)
                  v = this.getPlanData(v)
                  break
                case 10:
                  v.content = JSON.parse(v.content)
                  v = this.getPlanData(v)

                  if (v.content.webChatInquiryInfo && v.content.webChatInquiryInfo.questions) {
                    v.content.webChatInquiryInfo.questions.map(v2 => {
                      if (v2.questionsType === 3) {
                        v2['imgList'] = (v2.selectAnswerId && v2.selectAnswerId.split(',')) || []
                      }
                    })
                  }
                  break
              }
              return v
            })
            this.chatMap.list = list.concat(this.chatMap.list)
            if (this.chatMap.pageNo === 1) {
              this.$nextTick(() => {
                this.$refs['chat_content'].scrollTop = this.$refs['chat_content'].scrollHeight
              })
            } else {
              this.$nextTick(() => {
                this.$refs['chat_content'].scrollTop = this.$refs[`chat_record_${oldFirstChatVId}`][0].offsetTop
              })
            }
          } else {
            this.chatMap.hasMore = false
          }
        }
      },
      chatScroll: debounce(function () {
        if (this.chatMap.hasMore && !this.chatLoading) {
          const container = this.$refs['chat_content']
          if (container.scrollTop === 0) {
            this.chatMap.pageNo = this.chatMap.pageNo + 1
            this.getChatList()
          }
        }
      }, 300),
      handleStatusFn (obj = {}) {
        let isBols = false
        let status = obj.status || ['1', '2', '4']
        switch (obj.type) {
          case 1:
            let iswaiting = this.orderInfo.status == 1 // 待诊中
            let isSeeking = this.orderInfo.status == 4 // 就诊中
            let isDiagnosed = this.orderInfo.status == 2 && !this.orderInfo.existCtOrder // 未支付的已诊中
            let isFinish = this.orderInfo.status == 3 && !this.orderInfo.existCtOrder // 未支付的已结束
            if (!(iswaiting || isSeeking || isDiagnosed || isFinish)) {
              isBols = true
            }
            break
          case 2:
            break
          default:
            if (!status.includes(this.orderInfo.status)) {
              isBols = true
            }
            break
        }
        return isBols
      },
      validOperate (obj = {}) {
        const isBols = this.handleStatusFn(obj)
        if (isBols) {
          this.$message.warning(this.handleStatusMap[this.orderInfo.status].label)
        }
        return isBols
      },
      headerMoreShowChange () {
        this.headerMoreShow = !this.headerMoreShow
      },
      toolShowChange () {
        if (!this.isReady) {
          return false
        }
        this.toolMap.show = !this.toolMap.show
      },
      toInquirySelect () {
        let isBols = this.validOperate()
        if (!isBols) {
          this.$refs['inquirySelect'].open({
            webChatOrderInfoId: this.orderInfo.webChatOrderInfoId,
            doctorId: this.orderInfo.doctorMap.doctorId
          })
        }
      },
      toSendImage () {
        let isBols = this.validOperate()
        if (!isBols) {
          this.$refs.uploadImage.$el.querySelector('input').click()
        }
      },
      uploadImageSuccess (data) {
        this.sendMessage(1, data)
      },
      openGiveTime () {
        const isBols = this.validOperate({
          status: ['1', '2', '4', '-2']
        })
        if (!isBols) {
          this.giveTimeMap.visible = true
        }
      },
      closeGiveTime () {
        this.giveTimeMap.form.time = ''
        this.$nextTick(() => {
          this.$refs['giveTimeForm'].clearValidate()
        })
        this.giveTimeMap.visible = false
      },
      submitGiveTime () {
        this.$refs['giveTimeForm'].validate(async valid => {
          if (valid) {
            const res = await sendGiftTimeApi({
              orderId: this.orderId,
              time: this.giveTimeMap.form.time
            })
            if (res.code === 200) {
              this.$message.success('赠送成功')
              this.closeGiveTime()
              this.getOrderInfo()
            }
          }
        })
      },
      toChatHistory () {
        this.$refs['chatHistory'].open({
          webChatOrderInfoId: this.orderInfo.webChatOrderInfoId,
          doctorMap: this.orderInfo.doctorMap,
          patientMap: this.orderInfo.patientMap
        })
      },
      toRefundNumber () {
        const isBols = this.validOperate()
        if (!isBols) {
          this.$confirm('点击确定，系统将自动结束本次问诊，并将问诊费原路退回给用户。', '是否进行退号', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(async () => {
            const res = await outPatientApi({ webChatOrderInfoId: this.orderInfo.webChatOrderInfoId })
            if (res.code === 200) {
              this.getOrderInfo()
            }
          }).catch(() => {})
        }
      },
      toOverConsultation () {
        if (['-2', '3'].includes(this.orderInfo.status)) {
          this.$message.warning('咨询已结束')
          return false
        }
        const lastTime = this.orderInfo.completeTime ? this.orderInfo.completeTime : new Date().Format('yyyy-MM-dd hh:mm:ss')
        let useTime = this.formatTime(new Date(lastTime).getTime() - new Date(this.orderInfo.createTime).getTime()).slice(0, -3)
  
        let title = '是否提前结束咨询'
        let content = `在线咨询总时长${this.orderInfo.allTime}\r\n本次咨询已进行${useTime}`
        let confirmText = '确定'

        if (this.orderInfo.status === '1') {
          title = '结束未开始的问诊？'
          content = `确认后，本次咨询将直接关闭。该问诊费不会退还给患者。`
          confirmText = '确认结束'
        }

        this.$confirm(content, title, {
          customClass: 'chatRoom_confirm_dialog',
          confirmButtonText: confirmText,
          cancelButtonText: '取消'
        }).then(async () => {
          const res = await completeWebChat({ orderId: this.orderId })
          if (res.code === 200) {
            this.getOrderInfo()
          }
        }).catch(() => {})
      },
      sendText (e) {
        if (!this.isReady) {
          return false
        }
        e.preventDefault()
        if (this.chatInput) {
          const isBols = this.validOperate()
          if (!isBols) {
            this.sendMessage(0, this.chatInput)
            this.chatInput = ''
          }
        }
      },
      toInquiry (chat) {
        const info = chat && chat.content.webChatInquiryInfo || null
        this.$refs['inquiryDetail'].open({
          webChatOrderInfoId: this.orderInfo.webChatOrderInfoId,
          templateId: (info && String(info.templateId)) || ''
        })
      },
      async readChatMsg () {
        const res = setReadWebChatMsg({
          webChatOrderInfoId: this.orderInfo.webChatOrderInfoId,
          type: 2
        })
      }
    },
    beforeDestroy () {
      clearInterval(this.remainingTimeClock)
      clearInterval(this.chatHeartClock)
      if (this.chatSocket) {
        this.chatSocket.close()
        this.chatSocket = null
      }
      this.isReady = false
    }
  }
</script>

<style lang="less" scoped>
  .chatRoom {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
  }

  .header {
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 12px 12px;
    width: 100%;
    background-color: #FFFDE9;
    border-bottom: 1px solid #E0E0E0;
  }

  .header_top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .header_top_status {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_icon {
    font-size: 12px;
    color: #667182;
  }

  .header_text {
    margin: 0 0 0 4px;
    font-size: 12px;
    color: #667182;
  }

  .header_time {
    font-weight: 600;
    font-size: 12px;
    color: #FE8F1F;
  }

  .header_top_btn {
    font-size: 12px;
    cursor: pointer;
  }

  .inquiry_item {
    margin: 4px 0 0 0;
  }

  .inquiry_description {
    line-height: 18px;
    font-size: 12px;
    color: #000000;
    
  }

  .inquiry_description.hidden {
    max-height: 36px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }

  .inquiry_row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-width: 0;
  }

  .inquiry_row_title {
    flex-shrink: 0;
    line-height: 18px;
    font-size: 12px;
    color: #000000;
  }

  .inquiry_row_imgRow {
    margin: -6px -6px 0 0;
    width: 100%;
  }

  .inquiry_row_img {
    margin: 6px 6px 0 0;
    width: 36px;
    height: 36px;
  }

  .inquiry_answer_text {
    line-height: 18px;
    font-size: 12px;
    color: #000000;
  }

  .header_more {
    margin: 5px auto 0;
    width: fit-content;
    cursor: pointer;
  }

  .header_more_text {
    font-size: 12px;
    color: #A4AFBA;
  }

  .header_more_icon {
    margin: 0 0 0 2px;
    font-size: 14px;
    color: #A4AFBA;
  }

  .content {
    flex-grow: 1;
    box-sizing: border-box;
    padding: 16px 12px;
    width: 100%;
    background-color: #F4F5F5;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .chat_list {
    width: 100%;
    overflow: hidden;
  }

  .chat_item {
    width: 100%;
  }

  .chat_item+.chat_item {
    margin: 10px 0 0 0;
  }

  .chat_system {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  
  .chat_system_text {
    box-sizing: border-box;
    padding: 2px 12px;
    line-height: 18px;
    font-size: 12px;
    color: #A4AFBA;
  }

  .chat_user {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .chat_user.other {
    flex-direction: row;
  }

  .chat_user.mine {
    flex-direction: row-reverse;
  }

  .chat_headImg {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    overflow: hidden;
  }

  .chat_user.other .chat_headImg {
    margin: 0 9px 0 0;
  }

  .chat_user.mine .chat_headImg {
    margin: 0 0 0 9px;
  }

  .chat_info {
    position: relative;
    z-index: 1;
    max-width: 75%;
    border-radius: 4px;
    background-color: #FFFFFF;
  }

  .chat_info::after {
    content: '';
    position: absolute;
    z-index: 2;
    top: 10px;
    width: 0px;
    height: 0px;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }

  .chat_user.other .chat_info::after {
    left: -10px;
    border-left: 5px solid transparent;
    border-right: 5px solid #FFFFFF;
  }

  .chat_user.mine .chat_info::after {
    right: -10px;
    border-left: 5px solid #FFFFFF;
    border-right: 5px solid transparent;
  }

  .chat_info.mine {
    background-color: #ABE97A;
  }

  .chat_user.mine .chat_info.mine::after {
    right: -10px;
    border-left: 5px solid #ABE97A;
    border-right: 5px solid transparent;
  }

  .chat_text {
    box-sizing: border-box;
    padding: 6px 10px;
    line-height: 20px;
    font-size: 14px;
    color: #1F2329;
    word-wrap: break-word;
    word-break: break-all;
  }

  .chat_image {
    box-sizing: border-box;
    padding: 6px 10px;
    overflow: hidden;
  }

  .chat_image_img {
    width: 50px;
    height: 50px;
  }

  .chat_voice {
    box-sizing: border-box;
    padding: 6px 10px;
    overflow: hidden;
  }

  .chat_voice_audio {
    width: 160px;
    height: 32px;
  }

  .chat_inquiry {
    box-sizing: border-box;
    padding: 6px 10px;
    width: 200px;
    overflow: hidden;
    cursor: pointer;
  }

  .inquiry_title {
    line-height: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .inquiry_info {
    margin: 4px 0 0 0;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
  }

  .inquiry_footer {
    box-sizing: border-box;
    margin: 8px 0 0 0;
    padding: 6px 0 0 0;
    width: 100%;
    line-height: 18px;
    font-size: 12px;
    color: #A4AFBA;
    text-align: center;
    border-top: 1px solid #F2F2F2;
  }

  .inquiry_footer.finished {
    color: #1890FF;
  }

  .chat_plan {
    box-sizing: border-box;
    padding: 6px 10px;
    width: 200px;
    overflow: hidden;
  }

  .plan_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .plan_header_title {
    line-height: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .plan_header_status {
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
  }

  .plan_patient {
    margin: 4px 0 0 0;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
  }

  .plan_diagnosis {
    margin: 4px 0 0 0;
    width: 100%;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .plan_content {
    margin: 4px 0 0 0;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
    word-wrap: break-word;
    word-break: break-all;
  }

  .chat_condition {
    box-sizing: border-box;
    padding: 6px 10px;
    width: 200px;
    overflow: hidden;
    cursor: pointer;
  }

  .condition_title {
    margin: 8px 0 0 0;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .condition_list {
    margin: 4px 0 0 0;
  }

  .condition_item+.condition_item {
    margin: 2px 0 0 0;
  }

  .condition_description {
    max-height: 72px;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }

  .condition_row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-width: 0;
  }

  .condition_row_title {
    flex-shrink: 0;
    line-height: 18px;
    font-size: 12px;
    color: #667182;
  }

  .condition_row_imgRow {
    width: 100%;
  }

  .condition_row_img {
    margin: 5px 5px 0 0;
    width: 50px;
    height: 50px;
  }

  .condition_answer_text {
    line-height: 18px;
    font-size: 12px;
    color: #667182;
  }

  .condition_footer {
    box-sizing: border-box;
    margin: 8px 0 0 0;
    padding: 6px 0 0 0;
    width: 100%;
    line-height: 18px;
    font-size: 12px;
    color: #1890FF;
    text-align: center;
    border-top: 1px solid #F2F2F2;
  }

  .footer {
    flex-shrink: 0;
    box-sizing: border-box;
    width: 100%;
    background-color: #FFFFFF;
    border-top: 1px solid #E0E0E0;
  }

  .footer_tools {
    box-sizing: border-box;
    padding: 0 10px;
    width: 100%;
  }

  .tools_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 32px;
  }

  .tools_header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .tools_header_left_icon {
    font-size: 14px;
    color: #51AAFE;
  }

  .tools_header_left_text {
    margin: 0 0 0 2px;
    font-size: 14px;
  }

  .tools_header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .tools_header_right_icon {
    padding: 4px;
    font-size: 14px;
    color: #798291;
    transform: rotate(90deg);
    border-radius: 50%;
    cursor: pointer;
  }

  .tools_header_right_icon:hover {
    background-color: #F0F1F3;
  }

  .tools_list {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 12px;
    padding: 10px 0;
    width: 100%;
  }

  .tools_item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
  }

  .tools_btn_block {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background-color: #F0F1F3;
    border-radius: 4px;
  }

  .tools_item:hover .tools_btn_block {
    background-color: #E2E3E4;
  }
  
  .tools_btn_icon {
    width: 24px;
    height: 24px;
  }

  .tools_btn_title {
    margin: 6px 0 0 0;
    font-size: 12px;
    color: #667182;
  }

  .footer_input {
    width: 100%;
    height: 120px;
    border-top: 1px solid #E0E0E0;
    overflow: hidden;
  }

  .footer_input_textarea {
    width: 100%;
    height: calc(100% - 40px);
  }

  .footer_input_textarea /deep/ .el-textarea__inner {
    box-sizing: border-box;
    padding: 10px 10px;
    width: 100%;
    height: 100%;
    font-size: 12px;
    color: #A4AFBA;
    background-color: #FFFFFF;
    border: none;
  }

  .footer_input_textarea /deep/ .el-textarea__inner::placeholder {
    font-size: 12px;
    color: #A4AFBA;
  }

  .footer_input_btn {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 10px;
    height: 40px;
  }

  .chatRoom_dialog /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .chatRoom_dialog /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .chatRoom_dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .chatRoom_dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .chatRoom_dialog /deep/ .el-dialog__footer {
    padding: 12px 16px;
  }

  .giveTime_dialog_content {
    padding: 12px 16px 0px;
  }

  .giveTime_select {
    width: 100%;
  }

  .giveTime_select_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin: 0 -1px -1px 0;
  }

  .giveTime_select_grid /deep/ .el-select-dropdown__item {
    padding: 0 0 0 0;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-weight: 400;
    border-right: 1px solid #D3D3D5;
    border-bottom: 1px solid #D3D3D5;
  }

  .giveTime_select_grid /deep/ .el-select-dropdown__item.selected {
    background-color: #E8F4FF;
  }
</style>

<style>
  .giveTime_select_popper .el-select-dropdown__list {
    padding: 0 0 0 0;
    overflow: hidden;
  }

  .chatRoom_confirm_dialog .el-message-box__message{
    white-space: pre-wrap;
  }
</style>